export const subscriptionFeatures = {
  subscription: true,
};
